var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0H0V55H55V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 27.5C54 42.1355 42.1355 54 27.5 54C12.8645 54 1 42.1355 1 27.5C1 12.8645 12.8645 1 27.5 1C42.1355 0.999999 54 12.8645 54 27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8185 27.4992C44.8944 21.2922 41.5731 15.5396 36.1598 12.5018C30.9402 9.57269 24.5632 9.61158 19.3798 12.6042L18.6597 13.02C13.4763 16.0126 10.2541 21.5158 10.181 27.5007C10.1052 33.7077 13.4264 39.4602 18.8397 42.498C24.0593 45.4271 30.4363 45.3882 35.6197 42.3956L36.3398 41.9798C41.5232 38.9872 44.7455 33.484 44.8185 27.4992Z",
    fill: "url(#paint0_linear_315_1305)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1801 31.567C45.6606 29.0584 45.6606 25.9435 44.1801 23.4349L39.3614 15.2699C37.9226 12.832 35.3026 11.3359 32.4717 11.3359H22.5277C19.6969 11.3359 17.0768 12.832 15.638 15.2699L10.8193 23.4349C9.33888 25.9435 9.33888 29.0584 10.8193 31.567L15.638 39.732C17.0768 42.1699 19.6969 43.6659 22.5277 43.6659H32.4718C35.3026 43.6659 37.9226 42.1699 39.3614 39.732L44.1801 31.567Z",
    fill: "url(#paint1_linear_315_1305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5156 27.2147C21.5156 27.4225 21.5982 27.6218 21.7451 27.7688C21.8921 27.9157 22.0914 27.9983 22.2992 27.9983H31.378L28.0133 31.3615C27.8661 31.5086 27.7835 31.7082 27.7835 31.9163C27.7835 32.1244 27.8661 32.3239 28.0133 32.4711C28.1604 32.6182 28.36 32.7009 28.568 32.7009C28.7761 32.7009 28.9757 32.6182 29.1228 32.4711L33.8244 27.7695C33.8974 27.6967 33.9553 27.6102 33.9948 27.515C34.0343 27.4198 34.0547 27.3177 34.0547 27.2147C34.0547 27.1116 34.0343 27.0095 33.9948 26.9143C33.9553 26.8191 33.8974 26.7327 33.8244 26.6599L29.1228 21.9583C28.9757 21.8111 28.7761 21.7285 28.568 21.7285C28.36 21.7285 28.1604 21.8111 28.0133 21.9583C27.8661 22.1054 27.7835 22.305 27.7835 22.5131C27.7835 22.7211 27.8661 22.9207 28.0133 23.0678L31.378 26.4311H22.2992C22.0914 26.4311 21.8921 26.5136 21.7451 26.6606C21.5982 26.8075 21.5156 27.0068 21.5156 27.2147Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_315_1305",
    x1: 19.0198,
    y1: 12.8121,
    x2: 35.9798,
    y2: 42.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_315_1305",
    x1: 27.4997,
    y1: 11.3359,
    x2: 27.4997,
    y2: 43.6659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexButton);
export default __webpack_public_path__ + "static/media/hex-button.0ffbed44c7b7da0861abcddd3e95872a.svg";
export { ForwardRef as ReactComponent };